module.exports = __webpack_public_path__ + "static/media/ramh.9571db4d.png";